import { forwardRef } from "react";

import Select from "react-select";

import { cx } from "@/utils";

import styles from "./SelectWithValidation.module.css";

const SelectWithValidation = forwardRef(({ className, ...props }, ref) => (
  <Select
    classNamePrefix="react-select"
    ref={ref}
    className={cx(styles.root, className)}
    {...props}
  />
));

SelectWithValidation.displayName = "SelectWithValidation";

export { SelectWithValidation };
